import { h } from "preact";
import picostyle from "picostyle";

const style = picostyle(h);

export const Button = style('button')({
  position: 'absolute',
  right: '10px',
  top: '10px',
  width: '10px',
  height: '10px',
  display: 'inline-block',
  appearance: 'none',
  padding: '0',
  cursor: 'pointer',
  border: 'none',
  background: 'none',
});
